import { createGlobalStyle } from 'styled-components';

import SoleilBoldWoff from '../assets/fonts/soleil-bold.woff';
import SoleilBoldWoff2 from '../assets/fonts/soleil-bold.woff2';
import SoleilBookWoff from '../assets/fonts/soleil-book.woff';
import SoleilBookWoff2 from '../assets/fonts/soleil-book.woff2';
import SoleilLightWoff from '../assets/fonts/soleil-light.woff';
import SoleilLightWoff2 from '../assets/fonts/soleil-light.woff2';
import SoleilWoff from '../assets/fonts/soleil-regular.woff';
import SoleilWoff2 from '../assets/fonts/soleil-regular.woff2';

const FontLoader = createGlobalStyle`
  @font-face {
    font-display: auto;
    font-family: Soleil;
    font-weight: 300;
    src: url(${SoleilLightWoff2}) format('woff2'), url(${SoleilLightWoff}) format('woff');
  }

  @font-face {
    font-display: auto;
    font-family: Soleil;
    font-weight: 400;
    src: url(${SoleilWoff2}) format('woff2'), url(${SoleilWoff}) format('woff');
  }

  @font-face {
    font-display: auto;
    font-family: Soleil;
    font-weight: 500;
    src: url(${SoleilBookWoff2}) format('woff2'), url(${SoleilBookWoff}) format('woff');
  }

  @font-face {
    font-display: auto;
    font-family: Soleil;
    font-weight: 600;
    src: url(${SoleilBoldWoff2}) format('woff2'), url(${SoleilBoldWoff}) format('woff');
  }
`;

export default FontLoader;
